export default "__VITE_ASSET__CG3u_9Ja__"